import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor() { }

  public getErrorMessage(response: HttpErrorResponse): string {
    let errorMessage: string = "";

    if (response.status == 401) {
      // Do nothing since this will cause a redirect anyway
    } else if (response.status == 403) {
      errorMessage = "You are not authorized to perform this action."
    } else if (response.error && response.error.message) {
      errorMessage = response.error.message;
    } else if (response.error && typeof response.error === 'string') {
      errorMessage = response.error;
    } else {
      errorMessage = response.message;
    }

    return errorMessage;
  }
}
